import React from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Container,
    Row,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Col,
    Spinner
  } from "reactstrap";
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function TrocarSenha({history}) {    
    const session = getSessionCookie();

    const { register, errors, handleSubmit, setValue } = useForm({ mode: "onBlur" });
    
    const[loading, set_loading] = React.useState(false);

    const onSubmit = (data) => {                

        if (data.novaSenha.length < 5){
            showMessage("Atenção", "Informe uma senha com pelo menos 5 dígitos!", 'warning' , null);        
            return;
        }

        if (data.novaSenha != data.confirmarSenha)
        {
            showMessage("Atenção", "A confirmação da senha não confere com a nova senha!", 'warning' , null);        
            return;
        }

        let jsonSubmit = {
            login: session.login,
            password: data.novaSenha,
            password_antiga: data.senha
        }

        set_loading(true);
        api_PUT(`usuario/alterarsenha/`, jsonSubmit).then(result => {
        set_loading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else{
            showMessage("Aviso", "Senha alterada com sucesso!", 'success', null);
            setValue("senha", "");
            setValue("novaSenha", "");
            setValue("confirmarSenha", "");
        }
        });
    };

  return (
    <>
        <Header />
        <Container className="mt--9" fluid>          
            <Row>
              <Container className="mt-1" fluid>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                        <Col md="12">
                          <strong> Trocar Senha</strong>
                        </Col>                        
                      </Row>                          
                  </CardHeader>  
                  <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                          <Col md="4">
                                <FormGroup>
                                    <label>Senha Antiga</label>
                                    <br/>
                                    <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Senha" type="password" name="senha" innerRef={register({ required: true })}/>
                                    </InputGroup>
                                    {errors.senha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                          </Col>
                          <Col md="4">
                                <FormGroup>
                                    <label>Nova Senha</label>
                                    <br/>
                                    <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Senha" type="password" name="novaSenha" innerRef={register({ required: true })}/>
                                    </InputGroup>
                                    {errors.novaSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                          </Col>
                          <Col md="4">
                                <FormGroup>
                                    <label>Confirmar Senha</label>
                                    <br/>
                                    <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Senha" type="password" name="confirmarSenha" innerRef={register({ required: true })}/>
                                    </InputGroup>
                                    {errors.confirmarSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                          </Col>                          
                      </Row>                                        
                      <Row className="text-center">
                          <Col md="12">
                                <Button className="my-4" color="success" type="submit">
                                    {loading && <Spinner size="sm" color="secondary" />} Salvar
                                </Button>
                          </Col>
                      </Row>        
                    </form>            
                  </CardBody>
                </Card>                  
              </Container>
            </Row>         

        </Container>        

    </>
  );
}
